/* THE EEL (LS-293): a silt eel, river-brown with a sand stripe, so it reads on teal water, seen from above as it swims -- thirteen columns of
 * body on a sine that travels a step a frame, so the eight frames are one wave passing down it, the head still
 * and its one yellow eye on the surface. It lives in the water and only the water: deep or shallow, never land.
 * Generated once from a small script and kept as data like every other actor. */

export const eel_0 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '........oo......',
  '.......oCCo.....',
  '......oCssCo....',
  '.o...oCsCCsCo...',
  'oCoooCsCooCCCoo.',
  '.oCCCsCo..ooCCyo',
  '.oCCsCo.....oCCo',
  '..ooCo.......oo.',
  '....o...........',
  '................',
  '................',
];

export const eel_1 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '......ooo.......',
  '.....oCCCo......',
  '....oCsssCo.....',
  '...oCsCCCsCo....',
  '.ooCsCoooCsCooo.',
  'oCCCCo...oCCCCyo',
  '.oCoo.....ooCCCo',
  '..o.........ooo.',
  '................',
  '................',
  '................',
];

export const eel_2 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '.....ooo........',
  '....oCCCo.......',
  '...oCsssCo......',
  '..oCsCCCsCo..oo.',
  '.oCCCoooCsCooCyo',
  'oCCoo...oCsCCCCo',
  '.oo......oCCCoo.',
  '..........ooo...',
  '................',
  '................',
  '................',
];

export const eel_3 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '...ooo..........',
  '..oCCCo.........',
  '.oCCssCo.....oo.',
  'oCCoCCsCo...oCyo',
  '.oo.ooCsCoooCCCo',
  '......oCsCCCCoo.',
  '.......oCssCo...',
  '........oCCo....',
  '.........oo.....',
  '................',
  '................',
];

export const eel_4 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '..ooo........oo.',
  '.oCCCo......oCyo',
  'oCCCsCo....oCCCo',
  '.oooCsCo..oCCoo.',
  '....oCsCooCCo...',
  '.....oCsCCCo....',
  '......oCssCo....',
  '.......oCCo.....',
  '........oo......',
  '................',
  '................',
];

export const eel_5 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '.oo.........ooo.',
  'oCCo.......oCCyo',
  '.oCCo.....oCCCCo',
  '..oCCo...oCCooo.',
  '...oCCoooCCo....',
  '...oCsCCCsCo....',
  '....oCsssCo.....',
  '.....oCCCo......',
  '......ooo.......',
  '................',
  '................',
];

export const eel_6 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '.o.........oo...',
  'oCo.......oCCoo.',
  '.oCo.....oCCCCyo',
  '.oCCo...oCCooCCo',
  '..oCCoooCsCo.oo.',
  '...oCCCCsCo.....',
  '...oCsssCo......',
  '....oCCCo.......',
  '.....ooo........',
  '................',
  '................',
];

export const eel_7 = [
  '................',
  '................',
  '................',
  '................',
  '................',
  '.........ooo....',
  '........oCCCo...',
  '.o.....oCssCCoo.',
  'oCo...oCsCCoCCyo',
  '.oCoooCsCoo.oCCo',
  '.oCCCCsCo....oo.',
  '..oCssCo........',
  '...oCCo.........',
  '....oo..........',
  '................',
  '................',
];
